import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  nameLabel: {
    id: 'Bo5xEx',
    defaultMessage: 'Name',
    description: 'Label for the workflow name field',
  },
  namePlaceholder: {
    id: 'C3zq7j',
    defaultMessage: 'Enter workflow name',
    description: 'Placeholder text for the workflow name field',
  },
  nameRequired: {
    id: 'jXN4+a',
    defaultMessage: 'Name is required',
    description: 'Error message when name is missing',
  },
  descriptionLabel: {
    id: 'cTWZrf',
    defaultMessage: 'Description',
    description: 'Label for the workflow description field',
  },
  descriptionPlaceholder: {
    id: 'Rzpq8C',
    defaultMessage: 'Enter workflow description (optional)',
    description: 'Placeholder text for the workflow description field',
  },
});
